import React, { useEffect, useState } from 'react';

import { Box, Divider, Skeleton, Stack } from '@chakra-ui/react';

import { AnonymousSmiley, Summarize } from 'assets/assetsV1/iconComponents';

import { ScrollableSectionNav } from 'uiToolkitV1/ScrollableSectionNav';

import { calculateCombinedData } from '../../OverallQuestionsResult/components/OverallScrollableNav';
import ResponseEmpHeader from '../../components/ResponseEmpHeader';
import { ResultRenderer } from '../../components/results/ResultRenderer';
import { useReviewResponseGoalData } from '../hooks/dataHooks';
import ReviewResultGoalSummary from './ReviewResultGoalSummary';

const SummarizeIcon = ({ ...props }) => <Summarize boxSize="20px" {...props} />;

const options = [
  {
    label: 'Summary',
    Icon: SummarizeIcon,
  },
];

const GoalScrollableNav = ({ questionId, goalId, firstResponseEmp, question, okr }) => {
  const { data, isLoading } = useReviewResponseGoalData({
    goalId,
    questionId,
    excludeEmployeeId: firstResponseEmp?.id,
  });
  const [scrollableSectionOptions, setScrollableSectionOptions] = useState([]);
  const combinedResponseData = calculateCombinedData({ question, firstResponseEmp, data });
  useEffect(() => {
    if (!isLoading) {
      const responseOptions = combinedResponseData?.map(({ employee }, index) => ({
        label: employee?.id ?? `Anonymous${index}`,
        src: employee?.profilePhotoSrc ?? null,
        displayName: employee?.displayName ?? 'Anonymous',
        Icon: AnonymousSmiley,
      }));
      setScrollableSectionOptions([...options, ...responseOptions]);
    }
  }, [isLoading]);

  const navOptions = scrollableSectionOptions;

  if (isLoading) {
    return (
      <Stack>
        <Skeleton height="20px" />
        <Skeleton height="20px" />
        <Skeleton height="20px" />
      </Stack>
    );
  }

  return (
    <Box
      sx={{
        width: '100%',
        '.scrollableSection': {
          background: '#F5F7F9',
        },
        borderRadius: '4px',
        overflow: 'hidden',
        paddingRight: '12px',
        maxHeight: '500px',
      }}
    >
      <ScrollableSectionNav options={navOptions} key={navOptions?.[0]?.label}>
        <Box bg="#F5F7F9" p="16px">
          <ReviewResultGoalSummary okr={okr} />
        </Box>

        {/*  // filter uncommon question responses for first person */}
        {combinedResponseData?.map((questionData, index) => (
          <Box bg="#F5F7F9" p="16px">
            <Divider my={2} />

            <ResponseEmpHeader
              displayName={navOptions[index + 1]?.displayName}
              src={navOptions[index + 1]?.src}
              peerType={questionData?.peerType}
              providerType={questionData?.providerType}
              employeeId={questionData?.employee?.id}
            />

            <ResultRenderer {...questionData} />
          </Box>
        ))}
      </ScrollableSectionNav>
    </Box>
  );
};

export default GoalScrollableNav;
